var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from "lodash";
import { DiagramBase } from '../basics/DiagramBase';
import { prepareDiagramData2D } from '../basics/Statistics';
import { setOrDef } from "../Helpers";
var Map = /** @class */ (function (_super) {
    __extends(Map, _super);
    function Map() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            data: undefined
        };
        _this.declareField = function (str, val, min, max) {
            var alpha = 32 + Math.floor(((128 * (val - min)) / (max - min)));
            var a = alpha.toString(16);
            var d = _this.props.diagram;
            return ({
                selected: true,
                itemStyle: {
                    color: setOrDef(d, function (x) { return x.selectedColor; }, "#950014") + a,
                    borderColor: setOrDef(d, function (x) { return x.selectedBorderColor; }, "#000000"),
                    borderWidth: setOrDef(d, function (x) { return x.borderWidth; }, 1),
                },
                silent: true,
                emphasis: {
                    itemStyle: {
                        areaColor: setOrDef(d, function (x) { return x.selectedColor; }, "#950014") + a,
                        borderColor: setOrDef(d, function (x) { return x.selectedBorderColor; }, "#000000"),
                        borderWidth: setOrDef(d, function (x) { return x.borderWidth; }, 1),
                    },
                },
                label: {
                    show: true,
                    formatter: setOrDef(d, function (x) { return x.formatter; }, '{name|{b}}{value|{c}%}'),
                    rich: d.richDefinitions ? d.richDefinitions : undefined,
                }
            });
        };
        _this.calcData = function (props) {
            var d = props.diagram;
            prepareDiagramData2D(props.diagram, {
                type: "map",
                map: d.mapName,
                roam: setOrDef(d, function (x) { return x.interactive; }, false),
                zoom: setOrDef(d, function (x) { return x.initialZoom; }, 1.2),
                itemStyle: {
                    normal: {
                        areaColor: setOrDef(d, function (x) { return x.unselectedColor; }, "#313639"),
                        borderColor: setOrDef(d, function (x) { return x.unselectedBorderColor; }, "#fff"),
                        borderWidth: setOrDef(d, function (x) { return x.borderWidth; }, 1)
                    },
                },
                silent: true,
                aspectScale: 1.0,
                emphasis: { label: { show: false }, itemStyle: { areaColor: setOrDef(d, function (x) { return x.unselectedColor; }, "#313639") } },
                hoverAnimation: false,
                showLegendSymbol: false,
            }).then(function (data) {
                //      console.log(data);
                _this.setState({ data: data });
                if (_this.props.onFieldsLoaded)
                    _this.props.onFieldsLoaded(data.fields);
            });
        };
        _this.showValues = function () {
            var data = _this.state.data;
            if (data && data.data && data.data.series && data.data.series.length > 0) {
                var max_1;
                var min_1;
                _.forEach(data.data.series[0].data, function (d) {
                    if (max_1 === undefined || max_1 < d.value)
                        max_1 = d.value;
                    if (min_1 === undefined || min_1 > d.value)
                        min_1 = d.value;
                });
                //console.log("min = ", min, ", max = ", max);
                _.forEach(data.data.series[0].data, function (d) {
                    var ele = _this.findDataElement({ "x": d.name });
                    if (ele && ele[0]) {
                        var toAdd = _this.declareField(d.name, d.value, min_1 ? min_1 : 0, max_1 ? max_1 : 0);
                        _.forEach(toAdd, function (v, i) { return ele[0][i] = v; });
                    }
                });
            }
        };
        _this.getOption = function () {
            if (!_this.state.data)
                return undefined;
            _this.showValues();
            var d = _this.props.diagram;
            var option = {
                backgroundColor: d.backgroundColor,
                color: d.colors ? d.colors.colors : undefined,
                series: _this.state.data && _this.state.data.data && _this.state.data.data.series && _this.state.data.data.series.length > 0 ? [_this.state.data.data.series[0]] : undefined,
            };
            return option;
        };
        _this.findDataElement = function (path) {
            if (Object.keys(path).length > 1)
                return undefined;
            var keys = _this.state.data.keys;
            var i = _.findIndex(keys[0].names, function (v) { return v === path[keys[0].key]; });
            if (i >= 0) {
                var series = _this.state.data.data.series;
                return [series[0].data[i]];
            }
            return undefined;
        };
        _this.getClickPath = function (data) {
            var toRet = {};
            toRet[_this.props.diagram.groupBy[0]] = data.name;
            return toRet;
        };
        _this.onClick = function (data) {
            _this.redraw();
            _super.prototype.onClick.call(_this, data);
        };
        _this.formatter = function (data) {
            return "<div style='display: inline-block; border-radius: 50%; background-color: " + data.color + "; width: 10px; height: 10px;'></div> <span>" + data.name + ":" + data.value + "</span>";
        };
        return _this;
    }
    Map.prototype.needRecalc = function (props) {
        var res = _super.prototype.needRecalc.call(this, props);
        var d = props.diagram;
        var n = this.props.diagram;
        res = res || d.mapName !== n.mapName;
        res = res || !_.isEqual(d.label, n.label);
        return res;
    };
    return Map;
}(DiagramBase));
export default Map;
//# sourceMappingURL=Map.js.map